import session from "./session";
import { RootAPI } from "./index";

export default {
  checkQRCodeCustomer(data) {
    return session().post(RootAPI + `customer/checkin`,data);

  },
};
